import { Box } from "@mui/material";
import { startCase } from "lodash";

import { Typography } from "@/Components/v2/atoms/Typography";

import EChartToolTip from "./EChartToolTip";
import { ToolTipLegendCircle } from "./ToolTipLegendCircle";

interface SalesByCompositionProps {
  title: string;
  seriesName: string;
  color: string;
  borderColor: string;
  total: string;
  value: string;
  isDollarViewSelected?: boolean;
  salesUnitsLabel?: string;
}

export const SalesByCompositionToolTip: React.FC<SalesByCompositionProps> = ({
  title,
  seriesName,
  color,
  borderColor,
  total,
  value,
  isDollarViewSelected,
  salesUnitsLabel,
}) => {
  return (
    <EChartToolTip>
      <Box
        sx={{
          padding: "0.75rem",
          margin: "0.75rem",
        }}
      >
        <Typography variant="body2" mb={2}>
          {title}
        </Typography>
        <Typography variant="body2" mb={2}>
          <ToolTipLegendCircle color={color} border={borderColor} />
          {seriesName}: {value} {!isDollarViewSelected && startCase(salesUnitsLabel)}
        </Typography>
        <Typography variant="body2" marginLeft={2.75} mb={2}>
          Total Sales: {total} {!isDollarViewSelected && startCase(salesUnitsLabel)}
        </Typography>
      </Box>
    </EChartToolTip>
  );
};
